/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { GGCCTarget } from '@app/core/types';
import { parseGGCCTarget } from './parse';

declare global {
  var GGCC_TARGET: GGCCTarget;
  var CC_IS_PRODUCTION: boolean | undefined;
}

window.GGCC_TARGET = parseGGCCTarget(import.meta.env?.GGCC_TARGET);

export const environment = {
  production: window.CC_IS_PRODUCTION ?? true,
  ggccTarget: parseGGCCTarget(import.meta.env?.GGCC_TARGET),
};

export const extModules = [];
